import { useEffect, useRef, useState, useContext } from 'react';
import { useNavigate } from "react-router";
import AuthenticationService from "../../Services/AuthenticationService";
import PartnerService from "../../Services/PartnerService";
import classes from "../../Assets/css/bootstrap.css";
import AuthContext from '../AuthContextComponent/AuthContext';
import $ from 'jquery';
import LoadingIndicator from "../CommonComponent/LoadingIndicator";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../Assets/css/bootstrap.css";
import { Modal, ModalFooter, ModalHeader, ModalTitle } from 'react-bootstrap';
import { ReactComponent as TenantResetWhiteIcon } from '../../Assets/img/Reset-primary-icon.svg';
import { ReactComponent as TenantCountinueIcon } from '../../Assets/img/Login.svg';
import { ReactComponent as SearchTenantIcon } from '../../Assets/img/SearchTenant.svg';
import { ReactComponent as SelectTenantSelectedIcon } from '../../Assets/img/SelectTenant.svg';
import { ReactComponent as SelectTenantUnSelectedIcon } from '../../Assets/img/UnselectTenant.svg';
import { ReactComponent as Error } from '../../Assets/img/Error.svg';

function SelectTenantPopup(props) {
    const authCtx = useContext(AuthContext);
    const [tenant, setTenant] = useState("notselected");
    const [error, setError] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [selectedCountry, setSelectedCountry] = useState("");
    const [selectedPartner, setSelectedPartner] = useState("");
    const [searchValue, setSearchValue] = useState("")
    const [searchPartnerValue, setSearchPartnerValue] = useState("")
    const [tenants, setTenants] = useState([]);
    const countryInputRef = useRef();
    const partnerInputRef = useRef();
    let navigate = useNavigate();

    useEffect(() => {
        Promise.all([PartnerService.getPartners(), PartnerService.GetCountries()])
            .then(([partners, countriesResponse]) => {
                const countries = countriesResponse.response || [];
                setTenants(partners.map((partner) => ({
                    countryName: countries.find((c) => c.countryId == partner.countryId)?.countryName || "",
                    partnerName: partner.partnerName
                })));
                setIsLoading(false);
            })
            .catch((err) => {
                setError(err.message || "Failed to load partners");
                setTenant("failed");
                setIsLoading(false);
            });
    }, []);

    function loadPartnerValues() {
        var countryName = $('#countryName').val();
        var data = [];
        tenants.map(tenant => (
            tenant.CountryName == countryName ? data.push(tenant.PartnerName) : -1
        ));
        var partnerName = "<select id='partnerName'>";
        for (var i = 0; i < data.length; i++) {
            partnerName = partnerName + '<option value=' + data[i] + '>' + data[i] + '</option>';
        }
        partnerName = partnerName + '</select>';
        $('#partnerName').html(partnerName);
    }
    function submitHandler(event) {
        event.preventDefault();
        if (selectedCountry === "" || selectedPartner === "") {
            setError("Select Country and Partner");
            setTenant("failed");
            return;
        }
        setIsLoading(true);
        const enteredCountry = selectedCountry;
        const enteredPartner = selectedPartner;
        var selectTenantDTO = {
            request: {
                CountryName: enteredCountry,
                PartnerName: enteredPartner
            }
        };
        AuthenticationService.SelectTenant(selectTenantDTO)
            .then(() => {
                authCtx.Tenant();
                setTenant("selected");
                authCtx.selectCountry(enteredCountry);
                authCtx.selectPartner(enteredPartner);
                props.onClose();
                //navigate("/Devices")
                //window.location.reload();
                props.onPageReset();
            })
            .catch((err) => {
                if (err.status == "404") {
                    setError(err.data);
                }
                else {
                    setError("Invalid Data");
                }
                setTenant("failed");
                setIsLoading(false);
            });
    }
    function showhandler(countryName) {
        setSelectedCountry(countryName);
    }
    function showpartnerhandler(partnerName) {
        if (selectedCountry != "") {
            setSelectedPartner(partnerName);
        }
        else {
            setTenant("failed");
            setError("Select Country");
        }
    }
    if (isLoading) {
        return (
            <div className="container">
                <LoadingIndicator size="large" message="Logging..." />
            </div>
        );
    }
    return (
        <Modal show={true} onHide={props.onClose} contentClassName="tenant-container">
            <ModalHeader className="tenent-header1" style={{ border: "none" }} closeButton >
                <ModalTitle>
                    <h1 className="tenant-header">Select Tenant </h1>
                </ModalTitle>

            </ModalHeader>
            {tenant == "selected" && <div>Tenant selection Sucessful</div>}
            {tenant == "failed" && <div className="alert alert-warning"><Error /><span className="message-popup-title">{error}</span></div>}
            <Modal.Body style={{ padding: '0' }}>
                <form onSubmit={submitHandler}>
                    <div>
                        <div className="tenant-label1">
                            <div>Country</div>
                        </div>
                        <div>
                            <div >
                                <input className="tenant-inputbox" aria-label="Default select example" aria-haspopup="true" aria-expanded="false" placeholder="Search Country" ref={countryInputRef} onLoad={loadPartnerValues} value={searchValue} onChange={e => setSearchValue(e.target.value)} />
                                <SearchTenantIcon className="tenant-searchicon" />
                            </div>
                            <div>
                                <div className="tenant-scrollbar">
                                    {Array.from(new Set(tenants?.filter(tenant => tenant.countryName.match(new RegExp(searchValue, "i"))).map(tenant => tenant.countryName))).map(countryName => (
                                        <div className="tenant-inputdiv" onClick={() => showhandler(countryName)}>
                                            {countryName}
                                            {selectedCountry != countryName && < SelectTenantUnSelectedIcon className="tenant-selected" />}
                                            {selectedCountry == countryName && < SelectTenantSelectedIcon className="tenant-selected" />}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div >
                        <div className="tenant-label2">Partner</div>
                        <div>
                            <div>
                                <input id="partnerName" className="tenant-inputbox1" aria-haspopup="true" aria-expanded="false" aria-label="Default select example" ref={partnerInputRef} placeholder="Search Partner" value={searchPartnerValue} onChange={e => setSearchPartnerValue(e.target.value)} />
                                <SearchTenantIcon className="tenant-searchicon1" />
                            </div>
                            <div>
                                <div className="tenant-scrollbar1" >
                                    {Array.from(new Set(tenants?.filter(a => (selectedCountry == "" || a.countryName == selectedCountry)).filter(tenant => tenant.partnerName.match(new RegExp(searchPartnerValue, "i"))).map(tenant => tenant.partnerName))).map(PartnerName => (
                                        <div className="tenant-inputdiv1" onClick={() => showpartnerhandler(PartnerName)}>
                                            {PartnerName}
                                            {selectedPartner != PartnerName && < SelectTenantUnSelectedIcon className="tenant-selected" />}
                                            {selectedPartner == PartnerName && < SelectTenantSelectedIcon className="tenant-selected" />}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                    <br />
                    <ModalFooter className="tenant-Footer" style={{ border: "none" }} >
                        <div>
                            <button type="reset" className="secondary-button" onClick={() => {
                                setSelectedCountry(""); setSelectedPartner(""); setTenant("notselected"); setError(""); }}>
                                <TenantResetWhiteIcon className="secondary-button-icon" />
                                <text className="secondary-button-text">Reset</text>
                            </button>
                            &nbsp;
                            <button type="submit" className="primary-button">
                                <TenantCountinueIcon className="primary-button-icon" />
                                <text className="primary-button-text"> Continue</text>
                            </button>
                        </div>
                    </ModalFooter>
                </form>
            </Modal.Body>
        </Modal>
    );
}
export default SelectTenantPopup;